






















































import { Component } from 'vue-property-decorator';
import { AnnouncementAudience, AnnouncementModel, AnnouncementType } from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import AnnouncementForm from '@/forms/AnnouncementForm.vue';
import { AnnouncementApi } from '@/services/AnnouncementApi';

@Component({
  components: {
    AnnouncementForm,
    FormSubmit,
    XIcon,
  },
})
export default class CreateAnnouncementModal extends mixins(BaseMixin, FormMixin) {
  model = this.defaultModel();

  defaultModel(): AnnouncementModel {
    return {
      audience: AnnouncementAudience.All,
      title: '',
      subtitle: '',
      content: '',
      type: AnnouncementType.Text,
      hasFeedbackForm: false,
    };
  }

  async mounted() {
    //
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await AnnouncementApi.create({
        audience: this.model.audience!,
        title: this.model.title!,
        subtitle: this.model.subtitle!,
        content: this.model.content!,
        type: this.model.type!,
        hasFeedbackForm: this.model.hasFeedbackForm!,
      });

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['create-announcement'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Announcements ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['titleisNotEmpty'],
      'title',
      'Bitte eine gültige Überschrift eingeben.',
    );
    this.addError(
      apiErrors['subtitleisNotEmpty'],
      'subtitle',
      'Bitte eine gültige Beschreibung eingeben.',
    );
    this.addError(apiErrors['contentisNotEmpty'], 'content', 'Bitte einen gültigen Text eingeben.');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
